import { render } from "./InitializeStore.vue?vue&type=template&id=e8871078"
import script from "./InitializeStore.vue?vue&type=script&lang=js"
export * from "./InitializeStore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__